/* import __COLOCATED_TEMPLATE__ from './coupon-line-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();